import React from "react";

import styled from "styled-components/macro";

import { getBackgroundGradientFromColorScheme } from "Utilities/Colors/colorUtils";

import { usePaymentPage } from "./PaymentPageContext";

export default function GradientBackground({
  children,
  hideDefaultBackground,
}) {
  const { state } = usePaymentPage();
  const { colorScheme } = state.fund;
  const background = getBackgroundGradientFromColorScheme(colorScheme);

  // the gradient background is only used on the payment page itself,
  // not when the payment page is used as part of other UI elements
  if (hideDefaultBackground) return null;

  return <Wrapper style={{ background }}>{children}</Wrapper>;
}

const Wrapper = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: -1;
`;
